import { useCallback, useEffect } from 'react'

import { Button, Text } from '@loadsmart/loadsmart-ui'

import analytics from 'legacy/utils/analytics'
import user from 'legacy/utils/user'

import { BodyWrapper, KamionBannerWrapper, TitleWrapper, Wrapper } from './KamionBidBanner.styles'

const KAMION_BID_URL =
  'https://lp.kamion.io/kamion-demo-request?utm_source=loadboard&utm_medium=display&utm_campaign=loadboard-journey-carrier-kamion-202203-&utm_content=step-1'

function KamionBidBanner() {
  const carrierFleetSize = user.get('carrierFleetSize')
  const isEnabled = ['small', 'medium'].includes(carrierFleetSize)

  const handleKamionRedirection = useCallback(() => {
    window.open(KAMION_BID_URL, '_blank', 'noopener')
    analytics.track('Kamion Bid Banner / Clicked')
  }, [])

  useEffect(function onView() {
    analytics.track('Kamion Bid Banner / View')
  }, [])

  if (!isEnabled) {
    return null
  }

  return (
    <Wrapper>
      <KamionBannerWrapper>
        <div>
          <TitleWrapper>
            <Text variant="heading-md-bold" color="color-neutral-white">
              Do you need a safety TMS tool?
            </Text>
          </TitleWrapper>
          <BodyWrapper>
            <Text variant="body" color="color-neutral-white">
              Track existing documents and receive automatic reminders when you need a safety or
              maintenance check.
            </Text>
          </BodyWrapper>
        </div>
        <div>
          <Button onClick={handleKamionRedirection} variant="primary">
            Try kamion by LoadSmart
          </Button>
        </div>
      </KamionBannerWrapper>
    </Wrapper>
  )
}

export { KamionBidBanner }
